import axios from 'axios';
import SERVER_URL from '../config/server';

// console.log('Axios instance created with base URL:', SERVER_URL);
const axiosInstance = axios.create({
  baseURL: SERVER_URL,
  withCredentials: true, // if you're using cookies/session
});

export default axiosInstance;
